import * as React from "react";
const ListContext = React.createContext({
  iconSize: "xs"
});
const _List = class _List extends React.Component {
  get spacing() {
    const { spacing, size, bordered, direction } = this.props;
    if (spacing) {
      return spacing;
    }
    if (bordered && direction !== "inline") {
      return "xlarge";
    }
    switch (size) {
      case "xsmall":
        return "medium";
      case "large":
      case "small":
      default:
        return "large";
    }
  }
  get horizontalSpacing() {
    const { spacing, horizontalSpacing = spacing, direction } = this.props;
    if (horizontalSpacing) {
      return horizontalSpacing;
    }
    if (direction === "inline") {
      return "xlarge";
    }
    return this.spacing;
  }
  get verticalSpacing() {
    const { spacing, verticalSpacing = spacing } = this.props;
    if (verticalSpacing) {
      return verticalSpacing;
    }
    return this.spacing;
  }
  BEM() {
    const classArray = ["list"];
    if (this.props.type) {
      classArray.push("list--" + this.props.type);
    }
    if (this.props.type === "icon") {
      classArray.push("list--icon-position-" + this.props.iconPosition);
    }
    if (this.props.size) {
      classArray.push("list--" + this.props.size);
    }
    if (this.props.direction) {
      classArray.push("list--direction-" + this.props.direction);
    }
    if (this.props.bordered) {
      classArray.push("list--bordered");
      if (this.props.outerBordered) {
        classArray.push("list--outer-bordered");
      }
    }
    if (this.props.fullWidth) {
      classArray.push("list--full-width");
    }
    if (this.horizontalSpacing) {
      classArray.push("list--hor-spacing-" + this.horizontalSpacing);
    }
    if (this.verticalSpacing) {
      classArray.push("list--ver-spacing-" + this.verticalSpacing);
    }
    if (this.props.numberSize) {
      classArray.push("list--number-size-" + this.props.numberSize);
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  render() {
    const {
      type,
      icon,
      iconPosition,
      size,
      iconClassName,
      className,
      children,
      bordered,
      outerBordered,
      fullWidth,
      spacing,
      horizontalSpacing,
      verticalSpacing,
      direction,
      numberSize,
      theme,
      ["aria-labelledby"]: ariaLabelledBy,
      ...rest
    } = this.props;
    const ListElement = type === "ordered" ? "ol" : "ul";
    const listContextValue = {
      icon,
      iconSize: size === "xsmall" ? "xxs" : size === "large" ? "sm" : "xs",
      iconClassName
    };
    return /* @__PURE__ */ React.createElement(ListContext.Provider, { value: listContextValue }, /* @__PURE__ */ React.createElement("div", { className: this.BEM(), "data-theme": theme, ...rest }, /* @__PURE__ */ React.createElement(ListElement, { className: "list__inner", role: "list", "aria-labelledby": ariaLabelledBy }, children)));
  }
};
_List.defaultProps = {
  outerBordered: true,
  iconPosition: "top",
  size: "small"
};
let List = _List;
export {
  List,
  ListContext
};
